module.exports = __webpack_public_path__ + "static/media/legendSVG.51d147a7.svg";